import { useEffect, useState } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { routes } from './';
import parseRoutes, { ParsedType } from './routerGenerator';
import { observer } from 'mobx-react';
import { RouteContext } from './provider';

const Router = () => {
  const [parsed, setParsed] = useState<ParsedType>({} as ParsedType);
  // 处理路由权限，生成路由和菜单和面包屑
  useEffect(() => {
    const data = parseRoutes(routes, (permissions?: any) => {
      return true;
    });
    setParsed(data);
  }, [routes]);

  return parsed.routerList?.length ? (
    <RouteContext.Provider value={parsed}>
      <RouterProvider router={createBrowserRouter(parsed.routerList)} />
    </RouteContext.Provider>
  ) : null;
};

export default observer(Router);
